// Array.prototype.at is unsupported on Safari < 15.4 (macOS Catalina), so index access is used instead.
const last = <ItemType>(items: readonly ItemType[]): ItemType | undefined => items[items.length - 1];

export default last;
